import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {PlaningArea, TimeRange, TimeRangeBindingType} from '../../../../api/src/template/template.model';
import {TableColumns} from '@inspark/inspark-components';
import {DayBindingValueModel} from '../day-bindingtype-edit/day-bindingtype.model';
import {TimerangeModel} from "../../../../api/src/timerange/timerange.model";

const bordersStrategy = (pa: TimeRange | null): { starton: DayBindingValueModel, endoff: DayBindingValueModel } => {

  if (!pa) {
    return {starton: 'start', endoff: 'end'};
  }

  switch (pa.bindingtype) {
    case 'BOTH_BORDERS':
      return {starton: 'start', endoff: 'end'};
      break;
    case 'LEFT_BORDER':
      return {starton: 'start', endoff: 'start'};
      break;
    case 'RIGHT_BORDER':
      return {starton: 'end', endoff: 'end'};
      break;
  }

  return {starton: 'start', endoff: 'end'};
};

const bindingTypeStrategy = (start: DayBindingValueModel, end: DayBindingValueModel): TimeRangeBindingType => {

  switch (true) {
    case start === 'start' && end === 'end':
      return 'BOTH_BORDERS';
      break;
    case start === 'start' && end === 'start':
      return 'LEFT_BORDER';
      break;
    case start === 'end' && end === 'end':
      return 'RIGHT_BORDER';
      break;
  }

  return 'BOTH_BORDERS';
};

const EMPTY_EDIT = {key: '', id: ''};

@Component({
  selector: 'app-globaltime-schedule-view',
  templateUrl: './globaltime-schedule-view.component.html',
  styleUrls: ['./globaltime-schedule-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobaltimeScheduleViewComponent implements OnInit, OnChanges {
  @Input() planningareas: PlaningArea[];
  @Input() configPrefix: string = '';
  @Input() timeRanges: TimerangeModel[] = [];
  @Input() editMode: 'default' | 'onOrOff' = 'default';
  @Output() addPlaningArea = new EventEmitter<boolean>();
  @Output() removePlaningArea = new EventEmitter<number>();
  @Output() addPlaningDateRane = new EventEmitter<number>();
  @Output() changeDays = new EventEmitter();
  @Output() updateTimerange = new EventEmitter();
  @Output() updateOnOrOff = new EventEmitter();
  @Output() validationError = new EventEmitter<string>();

  public items: any[] = [];
  public tableColumns: TableColumns[];
  public editField = EMPTY_EDIT;

  constructor() {
  }

  ngOnInit() {
    this.tableColumns = [{
      label: 'Count on',
      field: 'starton',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'On time',
      field: 'leftbound',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Count off',
      field: 'endoff',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Off time',
      field: 'rightbound',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Period on (min)',
      field: 'activesubrange',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Period off (min)',
      field: 'passivesubrange',
      width: '',
      isHidden: false,
      size: '50px'
    }];

    if (this.editMode === 'onOrOff') {
      this.tableColumns.push({
        label: 'OnValue',
        field: 'onvalue',
        width: '',
        isHidden: false,
        size: '50px'
      });
      this.tableColumns.push({
        label: 'OffValue',
        field: 'offvalue',
        width: '',
        isHidden: false,
        size: '50px'
      });
    }

    if (this.editMode === 'default') {
      this.tableColumns.push({
        label: '',
        field: '',
        width: '50px',
        isHidden: false,
        size: '50px'
      });
    }
    // "leftbound": -130, "rightbound": 160, "bindingtype": "BOTH_BORDERS", "activesubrange": 0, "passivesubrange": 0


  }

  ngOnChanges(changes) {
    const objectPlaningareaes = (pa, index): Record<string, any> => {


      const timerange: TimeRange | null = pa.timeranges?.length > 0 ? pa.timeranges[0] : null;


      const pivots: { starton: DayBindingValueModel, endoff: DayBindingValueModel } = bordersStrategy(timerange);

      // timerange всегда один или его нет
      const result = {
        index, ...pa.timeranges[0], ...pa,
        planingdates: {
          monday: pa.monday,
          tuesday: pa.tuesday,
          wednesday: pa.wednesday,
          thursday: pa.thursday,
          friday: pa.friday,
          saturday: pa.saturday,
          sunday: pa.sunday
        },
        intervals: pa.planningdates,
        repeat: pa.planningdates,
        ...pivots
      };
      if (this.editMode === 'onOrOff') {
        const timerange = this.timeRanges.find(tr => {
          if (pa.timeranges && pa.timeranges.length > 0) {
            return tr.timeRange.id === pa.timeranges[0].id;
          }
          return false;
        });
        result['onvalue'] = timerange ? timerange.valueOn : undefined;
        result['offvalue'] = timerange ? timerange.valueOff : undefined;
      }
      return result;
    };
    this.items = [];
    this.planningareas.forEach((_pa, index) => {
      if (['DAY_TIME'].includes(_pa.scheduletype)) {
        this.items.push(objectPlaningareaes(_pa, index));
      }
    });
  }

  updateDay(index, object: Record<string, boolean>): void {
    const row = this.items.find(item => item.index === index);
    if (row) {
      row.planingdates = {...row.planingdates, ...object};
      this.changeDays.emit({index, planingdates: row.planingdates});
    }

  }

  updateTimeBinding(index, field, value): void {
    this.editField = EMPTY_EDIT;

    const row = this.items.find(item => item.index === index);
    if (row) {
      row[field] = value;
    }
    this.updateRow(index, field);
  }
  updateText(index, field): void {
    const row = this.items.find(item => item.index === index);
    if (row) {
      let value = row[field];
      row[field] = value;
    }
    this.updateRow(index, field);
  }

  updateNumber(index, field): void {
    const row = this.items.find(item => item.index === index);
    if (row) {
      let value = parseInt(row[field], 10);
      if (isNaN(value)) {
        value = 0;
      }
      row[field] = value;
    }
    this.updateRow(index, field);
  }
  updateRow(index, field): void {
    this.editField = EMPTY_EDIT;
    const row = this.items.find(item => item.index === index);
    const pa = this.planningareas[index];
    if (row && pa) {
      if (['leftbound', 'rightbound', 'bindingtype', 'activesubrange', 'passivesubrange'].includes(field)) {
        const timeranges = pa.timeranges[0];
        timeranges[field] = row[field];
        this.updateTimerange.emit({index, timeranges});
        return;
      }
      if (['onvalue', 'offvalue'].includes(field)) {
        const timeranges = pa.timeranges[0];
        timeranges[field] = timeranges[field] = row[field];;
        this.updateOnOrOff.emit({index, timeranges});
        return;
      }
    }
  }

  changeBindingType(index: number, field: string, value: DayBindingValueModel): void {
    const row = this.items.find(item => item.index === index);
    row[field] = value;
    this.planningareas[index].timeranges.forEach(tr => {
      tr.bindingtype = bindingTypeStrategy(row.starton, row.endoff);
    });
  }

  days(days): string[] {
    return Object.entries(days).filter(({0: day, 1: value}) => value).map(({0: day, 1: value}) => day);
  }

  delete(id: number): void {
    this.removePlaningArea.emit(id);
  }

  addInterval(id: number): void {
    this.addPlaningDateRane.emit(id);
  }

  add(): void {
    this.addPlaningArea.emit(true);
  }

  edit(id, key) {
    if (this.editMode === 'onOrOff') {
      if (['onvalue', 'offvalue'].includes(key)) {
        this.editField = {id, key};
      }
      return;
    }
    this.editField = {id, key};
  }

}
